import { type LoaderFunction, redirect } from 'react-router-dom';
import { Paths } from '@src/paths.ts';
import authenticationService from '@src/api/services/AuthenticationService.ts';

export const logoutAction = async () => {
  await authenticationService.logout();
  return Response.redirect(Paths.LOGIN);
};

export const logoutLoader: LoaderFunction = async () => {
  const isLoggedIn = await authenticationService.isLoggedIn();
  if (!isLoggedIn) {
    return redirect(Paths.LOGIN);
  }
  return null;
};
